import type { QueryClient } from "@tanstack/react-query"

import {
  useAdminOrgBySlugQuery,
  useCurrentImpersonationSessionQuery,
  useCurrentUserQuery,
  useOrgDetailQuery,
  useOrgHomepageQuery,
  useOrgPropertySearchQuery,
  useSidebarDataQuery,
} from "@/src/graphql/public-generated-rq"

export const QUERY_STALE_TIME_MS = 5 * 60 * 1000

// Keep shared app queries fresh for five minutes to avoid refetching on every tab focus.
// Mutations invalidate affected queries explicitly; schema checks poll separately.
export const configureQueryDefaults = (queryClient: QueryClient) => {
  for (const rootKey of [
    useCurrentUserQuery.rootKey,
    useSidebarDataQuery.rootKey,
    useOrgDetailQuery.rootKey,
    useOrgHomepageQuery.rootKey,
    useAdminOrgBySlugQuery.rootKey,
    useOrgPropertySearchQuery.rootKey,
    useCurrentImpersonationSessionQuery.rootKey,
    "GetSchemaFields",
  ]) {
    queryClient.setQueryDefaults([rootKey], {
      staleTime: QUERY_STALE_TIME_MS,
    })
  }
}
